import React from 'react';
import { OrderExportConfiguration } from '../types/orderExportConfiguration';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { instanceToPlain } from 'class-transformer';

export interface OrderExportConfigurationContextProps {
  orderExportConfigurations: Map<string, OrderExportConfiguration>;
  setOrderExportConfigurations: (orderExportConfigurations: Map<string, OrderExportConfiguration>) => void;
  orderExportConfigurationsLoading: boolean;
}

const defaultContext: OrderExportConfigurationContextProps = {
  orderExportConfigurations: new Map(),
  setOrderExportConfigurations: () => {},
  orderExportConfigurationsLoading: false,
};

export const OrderExportConfigurationContext =
  React.createContext<OrderExportConfigurationContextProps>(defaultContext);

interface OrderExportConfigurationState {
  items: Record<string, any>[];
  loading: boolean;
}
export const orderExportConfigurationSlice = createSlice({
  name: 'orderExportConfiguration',
  initialState: { items: [], loading: true } as OrderExportConfigurationState,
  reducers: {
    reset: state => {
      state.items = [];
      state.loading = true;
    },
    setAll: (state, action: PayloadAction<OrderExportConfiguration[]>) => {
      state.items = action.payload.map(p => instanceToPlain(p));
    },
    addAll: (state, action: PayloadAction<OrderExportConfiguration[]>) => {
      const map = new Map([...state.items, ...action.payload.map(p => instanceToPlain(p))].map(pmd => [pmd.id, pmd]));
      state.items = [...map.values()];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});
